import { render, staticRenderFns } from "./errorTip.vue?vue&type=template&id=08075412&scoped=true"
import script from "./errorTip.vue?vue&type=script&lang=js"
export * from "./errorTip.vue?vue&type=script&lang=js"
import style0 from "./errorTip.vue?vue&type=style&index=0&id=08075412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08075412",
  null
  
)

export default component.exports